import React from 'react';
import './lmd.css';

export default function Lmd() {
	return (
		<section className="text-lmd">
			<div className="container">
				<h1>Licence - Master - Doctorat</h1>
				<span className="iusse-description">
					L'Université IUSSE offre aux étudiants des formations prestigieuses
					permettant d'accéder à un emploi et de valoriser leurs connaissances
					dans des secteurs scientifiques, du droit et d'économiques.
					<br />
					<br />
					Ces formations s'adressent tant aux laboratoires académiques que dans
					le monde socio-économique ou des secteurs professionnels spécifiques.
					Nos domaines d'expertise incluent notamment : l'enseignement, les
					carrières juridiques, les professions de santé, les services et bien
					d'autres secteurs d'activité.
					<br />
					<strong>NOS FILIÈRES</strong>
					<br />
					<strong>• Droit</strong>
					<br />
					<strong>• Sciences économiques</strong>
					<br />
					<strong>• Finances Comptabilité et Gestion des Entreprises</strong>
				</span>
			</div>
		</section>
	);
}
